__turbopack_context__.v({
  "container": "s7B-ZG_container",
  "fullPage": "s7B-ZG_fullPage",
});
